import { BaseColDefOptionalDataParams } from "ag-grid-community/dist/lib/entities/colDef";
import { ColDef, ColGroupDef } from "ag-grid-enterprise";
import { Product } from "models/dbModels/products/Product";
import { Badge } from "react-bootstrap";

export function getSystemStockConfig(): (ColDef<Product> | ColGroupDef<Product>)[] | null {
        
    return [{
            headerName: "Name",
            field: "name",
            flex: 2,
            checkboxSelection: (params) => params.data?.alreadyImported === false || params.data?.alreadyImported === null,
            headerCheckboxSelection: true,
            showDisabledCheckboxes: false,
        },     
        {
            headerName: "Managed Stock",
            field: "alreadyImported",
            flex: 1,
            cellRenderer: (params: BaseColDefOptionalDataParams<Product>) => {
                if (params.data?.alreadyImported === true){
                    return (<Badge className="me-1 badge-outline-success">Yes</Badge>);
                }
                return (<></>)
            },
        },     
        {
            headerName: "Created",
            flex: 2,
            valueGetter: (params) => params.data?.created == null? null: new Date(params.data?.created)
                .toLocaleString('en-au',{ hour12: true })
                .replace(",","").toUpperCase()
        },
        {
            headerName: "Last Updated",
            flex: 2,
            field: "lastModified",
            valueGetter: (params) => getLastUpdatedDate(params.data)           
        }
    ];
}

function getLastUpdatedDate(product: Product | undefined) : string | null{
   if (product == undefined)
        return null;

    let dates: Date[] = [];
    if(product.apns != undefined)
        product.apns.forEach(ap => dates.push(new Date(ap.lastProcessed)));
    
    if(product.pdes != undefined)
        product.pdes.forEach(pd => dates.push(new Date(pd.lastProcessed)));
    
    if(dates.length == 0)
        return null;

    if (dates.length > 1)
        dates.sort((a , b) => b.getTime() - a.getTime());    
    
    return dates[0].toLocaleString('en-au',{ hour12: true })
        .replace(",","").toUpperCase();
}